module.exports = __webpack_public_path__ + "static/img/nav3.d01fa350.svg";